import { gql } from '@apollo/client';

const DELETE_COURSE_CERTIFICATE = gql`
    mutation($input: DeleteCourseCertificateInput!) { 
        result: deleteCourseCertificate(input: $input) { 
            affectedRows
        }
    }
`;

export default DELETE_COURSE_CERTIFICATE;
